import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { ACCESSIBILITY_STATEMENT_PATH, FORM_PATH, LOGIN_APP_PATH } from '../consts/consts';
import Authorization from './Authorization';
import AccessibilityStatement from './AccessibilityStatement';
import { extractPathSegments, getStoredUuidPathSegment } from '../utils/urlUtils';
import { appendLangForLanguage } from '../utils/languageMapping';
import { useLanguage } from '../LanguageContext';
import QuestionnaireForm from './questionnaires/QuestionnaireForm';
import PreviewFormLoader from './PreviewFormLoader';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AppRoutes = (props: any) => {
  const location = useLocation();
  const { language } = useLanguage();
  const { setPathError } = props;

  useEffect(() => {
    if (/^\/preview\/[^/]+$/.test(location.pathname)) {
      setPathError(false);
      return;
    }
    try {
      extractPathSegments(location.pathname);
      setPathError(false);
    } catch {
      setPathError(true);
    }
  }, [location.pathname, setPathError]);

  const loginElement = (
    <Authorization
      showVerification={props.showVerification}
      setShowVerification={props.setShowVerification}
      inputPhoneOrEmail={props.inputPhoneOrEmail}
      setInputPhoneOrEmail={props.setInputPhoneOrEmail}
      sessionId={props.sessionId}
      setSessionId={props.setSessionId}
      onExit={props.logout}
      showModal={props.showModal}
      setShowModal={props.setShowModal}
      urlParams={props.urlParams}
      logout={props.logout}
      setFormData={props.setFormData}
      verificationError={props.verificationError}
      setVerificationError={props.setVerificationError}
    />
  );

  const formElement = (
    <QuestionnaireForm
      formData={props.formData}
      setFormData={props.setFormData}
      loadingForm={props.loadingForm}
      logout={props.logout}
    />
  );

  // Route `path` must be pathname-only; query params (?lang=) break matching in React Router.
  const loginPath = () => {
    const uuid = getStoredUuidPathSegment();
    return `${LOGIN_APP_PATH}/${uuid}`;
  };

  const formPath = () => {
    const uuid = getStoredUuidPathSegment();
    return `${FORM_PATH}/${uuid}`;
  };

  const loginPathWithLang = () => appendLangForLanguage(loginPath(), language);

  const previewElement = (
    <PreviewFormLoader
      formData={props.formData}
      setFormData={props.setFormData}
      logout={props.logout}
    />
  );

  return (
    <Routes>
      <Route path='/preview/:linkId' element={previewElement} />
      <Route path={loginPath()} element={loginElement} />
      <Route path={ACCESSIBILITY_STATEMENT_PATH} element={<AccessibilityStatement />} />
      <Route path={formPath()} element={formElement} />
      <Route path='/*' element={<Navigate to={loginPathWithLang()} replace />} />
    </Routes>
  );
};

export default AppRoutes;
